import { render, staticRenderFns } from "./TextFieldConfigView.vue?vue&type=template&id=045191fc&scoped=true&"
import script from "./TextFieldConfigView.vue?vue&type=script&lang=js&"
export * from "./TextFieldConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045191fc",
  null
  
)

export default component.exports